import { useMemo } from 'react';

import { createQueryKeys } from '@/shared/query-keys';

import { useWorkspaceId } from './use-workspace-id';

export function useQueryKeys() {
  const { workspaceId } = useWorkspaceId();
  return useMemo(() => createQueryKeys(workspaceId), [workspaceId]);
}
